//@flow
import { CONFIRMATION_MESSAGE } from "./constants"

export const confirmDeletePath = (
  successPath: string,
  attractLoopId: string,
  id: string
): Object => ({
  pathname: `/admin/slides/${attractLoopId}/${id}/confirm/delete`,
  state: {
    modal: true,
    successPath: successPath,
    message: CONFIRMATION_MESSAGE
  }
})



// WEBPACK FOOTER //
// ./src/Slides/helpers.js